import { render } from "./SlideSection.vue?vue&type=template&id=55d7bed0&scoped=true"
import script from "./SlideSection.vue?vue&type=script&lang=js"
export * from "./SlideSection.vue?vue&type=script&lang=js"

import "./SlideSection.vue?vue&type=style&index=0&id=55d7bed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d7bed0"]])

export default __exports__